import React from "react";
import VacacionesEmpleado from "../../VacacionesEmpleado/VacacionesEmpleado";

function getAniosAntiguedad(fechaIngreso) {
  if (!fechaIngreso) return 0;
  const ingreso = new Date(fechaIngreso);
  const hoy = new Date();
  let years = hoy.getFullYear() - ingreso.getFullYear();
  if (
    hoy.getMonth() < ingreso.getMonth() ||
    (hoy.getMonth() === ingreso.getMonth() && hoy.getDate() < ingreso.getDate())
  ) {
    years -= 1;
  }
  return Math.max(years, 0);
}

function calcularDiasVacaciones(anios) {
  if (anios < 1) return 0;
  const tabla = { 1: 12, 2: 14, 3: 16, 4: 18, 5: 20 };
  if (tabla[anios]) return tabla[anios];
  if (anios <= 10) return 22;
  if (anios <= 15) return 24;
  if (anios <= 20) return 26;
  if (anios <= 25) return 28;
  if (anios <= 30) return 30;
  return 32;
}

export default function EditVacaciones({ values, handleChange }) {
  const vacaciones = values.vacacionesTomadas || [];

  const handleAddVacacion = ({ anio, dias, fechas: nuevasFechas, folio }) => {
    const actuales = values.vacacionesTomadas || [];

    // Evitar duplicados por folio
    const filtradas = actuales.filter(v => v.folio !== folio);

    const nuevas = [
      ...filtradas,
      {
        folio,
        dias: nuevasFechas.length,
        fechas: nuevasFechas,
        anio,
      }
    ];

    handleChange({
      target: {
        name: "vacacionesTomadas",
        value: nuevas,
      },
    });

    // También actualizar los campos legacy si los usas en otros lados
    handleChange({ target: { name: "vacacionFolio", value: folio } });
    handleChange({ target: { name: "vacacionDias", value: nuevasFechas.length } });
    handleChange({ target: { name: "vacacionFechas", value: nuevasFechas.join(",") } });
    handleChange({ target: { name: "vacacionAnio", value: anio } });
  };


  const aniosAntiguedad = getAniosAntiguedad(values.fechaIngreso);
  const totalPermitidos = calcularDiasVacaciones(aniosAntiguedad);
  const diasUsados = vacaciones.reduce((sum, v) => sum + Number(v.dias || 0), 0);
  const diasDisponibles = totalPermitidos - diasUsados;
  const sinDerecho = aniosAntiguedad < 1;

  return (
    <div className="mb-4">
      <h4 className="mb-3">Vacaciones</h4>

      <div className="mb-3 p-3 rounded border bg-light-subtle text-dark small">
        <p className="mb-1">🗓️ Antigüedad: <strong>{aniosAntiguedad}</strong> años</p>
        <p className="mb-1">✅ Días que te corresponden: <strong>{totalPermitidos}</strong></p>
        <p className="mb-1">⌛ Días que has usado: <strong>{diasUsados}</strong></p>
        <p className="mb-0">🟢 Días disponibles: <strong>{diasDisponibles}</strong></p>
      </div>

      {sinDerecho ? (
        <div className="alert alert-danger" role="alert">
          Este empleado aún no cumple un año en la empresa y no tiene derecho a vacaciones.
        </div>
      ) : (
        <VacacionesEmpleado
          vacacionesTomadas={vacaciones}
          diasDisponibles={diasDisponibles}
          onAddVacacion={handleAddVacacion}
        />
      )}
    </div>
  );
}
